import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1$1 from '@ngrx/store';
import { LoadPlayerOnceAction, LoadGameaccountAction, getPlayer, getGameaccounts, entryAvailable } from '@play/state';
import { filter, map } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@play/common';
import { CommonsLocationModule } from '@play/common';

class SteamProfileLinkComponent {
    constructor(links) {
        this.links = links;
    }
    ngOnInit() { }
    getSteamProfileLink(steamId) {
        return this.links.steamProfileLink(steamId);
    }
}
SteamProfileLinkComponent.ɵfac = function SteamProfileLinkComponent_Factory(t) { return new (t || SteamProfileLinkComponent)(i0.ɵɵdirectiveInject(i1.LinkService)); };
SteamProfileLinkComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SteamProfileLinkComponent, selectors: [["steam-profile-link"]], inputs: { gameAccount: "gameAccount" }, decls: 2, vars: 2, consts: [["target", "_blank", 3, "locationHref"]], template: function SteamProfileLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("locationHref", ctx.getSteamProfileLink(ctx.gameAccount.internalValue));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.gameAccount.value, "\n");
    } }, directives: [i1.LocationDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SteamProfileLinkComponent, [{
        type: Component,
        args: [{
                selector: "steam-profile-link",
                templateUrl: "./steam-profile-link.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.LinkService }]; }, { gameAccount: [{
            type: Input
        }] }); })();

function PlayerGameAccountTextComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "steam-profile-link", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const gameAccount_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("gameAccount", gameAccount_r1);
} }
function PlayerGameAccountTextComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const gameAccount_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", gameAccount_r1 == null ? null : gameAccount_r1.value, " ");
} }
function PlayerGameAccountTextComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainerStart(1, 1);
    i0.ɵɵtemplate(2, PlayerGameAccountTextComponent_ng_container_0_ng_container_2_Template, 2, 1, "ng-container", 2);
    i0.ɵɵtemplate(3, PlayerGameAccountTextComponent_ng_container_0_ng_container_3_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r0.gameAccountType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "steam_account");
} }
class PlayerGameAccountTextComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.store.dispatch(new LoadPlayerOnceAction(this.playerId));
        this.store.dispatch(new LoadGameaccountAction(this.playerId));
        this.player$ = this.store.select(getPlayer(this.playerId));
        this.playerGameAccount$ = this.store.select(getGameaccounts(this.playerId)).pipe(filter(entryAvailable), map(gameAccounts => gameAccounts.entry.find(gameAccount => gameAccount.type === this.gameAccountType)));
    }
}
PlayerGameAccountTextComponent.ɵfac = function PlayerGameAccountTextComponent_Factory(t) { return new (t || PlayerGameAccountTextComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
PlayerGameAccountTextComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PlayerGameAccountTextComponent, selectors: [["player-game-account-text"]], inputs: { playerId: "playerId", gameAccountType: "gameAccountType" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [3, "gameAccount"]], template: function PlayerGameAccountTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlayerGameAccountTextComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.playerGameAccount$));
    } }, directives: [i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i2.NgSwitchDefault, SteamProfileLinkComponent], pipes: [i2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayerGameAccountTextComponent, [{
        type: Component,
        args: [{
                selector: "player-game-account-text",
                templateUrl: "./player-game-account-text.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { playerId: [{
            type: Input
        }], gameAccountType: [{
            type: Input
        }] }); })();

class PlayerModule {
}
PlayerModule.ɵfac = function PlayerModule_Factory(t) { return new (t || PlayerModule)(); };
PlayerModule.ɵmod = i0.ɵɵdefineNgModule({ type: PlayerModule });
PlayerModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, CommonsLocationModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PlayerModule, { declarations: [PlayerGameAccountTextComponent, SteamProfileLinkComponent], imports: [CommonModule, CommonsLocationModule], exports: [PlayerGameAccountTextComponent, SteamProfileLinkComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayerModule, [{
        type: NgModule,
        args: [{
                declarations: [PlayerGameAccountTextComponent, SteamProfileLinkComponent],
                imports: [CommonModule, CommonsLocationModule],
                exports: [PlayerGameAccountTextComponent, SteamProfileLinkComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of player
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PlayerGameAccountTextComponent, PlayerModule, SteamProfileLinkComponent };
//# sourceMappingURL=play-player.js.map
